const useShowNewHeader = () => {
  return true;
};

export default useShowNewHeader;
